import { fetchCoupons } from '@musinsa/apis-curator';
import {
  lazyPipe,
  validateServiceRequest,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';
import { getCouponExpirationText } from './coupon-expiration.util';
import {
  type GetCouponsServiceRequest,
  GetCouponsServiceRequestSchema,
  type GetCouponsServiceResponse,
  GetCouponsServiceResponseSchema,
} from './getCoupons.dto';

const transformApiResponseToServiceResponse = async (
  request: GetCouponsServiceRequest,
): Promise<GetCouponsServiceResponse> => {
  const response = await fetchCoupons({
    shopTitle: request.shopTitle,
    page: request.page,
    size: request.size,
  });

  const list = response.data.list.map((coupon) => ({
    ...coupon,
    expirationText: getCouponExpirationText(coupon.useEndDate),
  }));

  const hasNextPage = response.link?.next != null;
  const nextPage = hasNextPage && request.page != null ? request.page + 1 : undefined;

  return {
    list,
    pagination: {
      hasNextPage,
      nextPage,
    },
  };
};

export const getCouponsService = withServiceErrorCapture(
  lazyPipe(
    validateServiceRequest(GetCouponsServiceRequestSchema),
    transformApiResponseToServiceResponse,
    validateServiceResponse(GetCouponsServiceResponseSchema),
  ),
);
